import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useDeleteEnquiry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/enquiry/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["enquiryList"] });
    },
  });
};
